/**
 * Used when shape type in helplines system is off.
 */
export class NoShape {
    getShape() {
        return [];
    }
    moveHandle() { }
}
//# sourceMappingURL=NoShape.js.map